import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import download from '../images/download-doc.svg';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Button, IconButton } from '@mui/material';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import ReportsAGGrid from "../../reports/reportsGrid/reportsAGGrid";
import CloseIcon from "@mui/icons-material/Close";

const styles = (theme) => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10',
  },
  padding10px: {
    padding: '10px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
});

const TransactionSortObj = {
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  total_bins: { tableName: '', sortColumn: 'total_bins' },
  available_bins: { tableName: '', sortColumn: 'available_bins' },
  use_bins: { tableName: '', sortColumn: 'use_bins' },
  stock_bins: { tableName: '', sortColumn: 'stock_bins' },
  box_utilization: { tableName: '', sortColumn: 'box_utilization' },
  utilization_date: { tableName: '', sortColumn: 'utilization_date' },
}

let BoxUtitlizationFilterObj = {
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class KioskBoxUtilization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 25,
      loader: false,
      isDataEmpty: true,
      data: [],
      totalRecords: 0,
      isButtonDisabled: false,
      toggleGraph: false,
      graphUrl: '',
      selectedYear: new Date().getFullYear() - 1,
    };
  }

  componentDidMount() {
    this.fetchGraph();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/KioskUtilizationReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Elements = [
          [
            'Id',
            'Store',
            'Box',
            'Total Bins',
            'Available Bins',
            'Use Bins',
            'Stocked Bins',
            'Utilization',
            'Date',
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Elements.push([
                i.store,
                i.box,
                i.total_bins,
                i.available_bins,
                i.use_bins,
                i.stock_bins,
                i.box_utilization ? i.box_utilization + '%' : '',
                i.utilization_date
                  ? this.convertToTimeZone(i && i.utilization_date)
                  : '',
              ]);
            }

            for (let i of Elements) {
              csvRow.push(i.join(','));
            }
            let csvString = csvRow.join('%0A');
            let element = document.createElement('a');
            element.href = 'data:attachment/csv.' + csvString;
            element.target = '_Blank';
            element.download = 'KioskUtilizationReport.csv';
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  }

  fetchGraph(isEmailRequested = false) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilizationGraph', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        currentYear: this.state.selectedYear,
        isEmailRequested,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ loader: false, graphUrl: uData && uData.graphUrl });
      })
      .catch((reason) => {
        this.setState({ loader: false });
        console.error(reason);
      });
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      BoxUtitlizationFilterObj.searchObject = null;
      BoxUtitlizationFilterObj.fromdate = '';
      BoxUtitlizationFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        BoxUtitlizationFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set fromdate and todate
        if (filterObject.utilization_date) {
          const dateValue = filterObject.utilization_date;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              BoxUtitlizationFilterObj.fromdate = date1
              BoxUtitlizationFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              BoxUtitlizationFilterObj.fromdate = date1
              BoxUtitlizationFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              BoxUtitlizationFilterObj.fromdate = date
              BoxUtitlizationFilterObj.todate = ''
            } else {
              BoxUtitlizationFilterObj.todate = date
              BoxUtitlizationFilterObj.fromdate = ''
            }
          }
        } else {
          BoxUtitlizationFilterObj.todate = '';
          BoxUtitlizationFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            BoxUtitlizationFilterObj.searchObject = null
          } else {
            BoxUtitlizationFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          BoxUtitlizationFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          BoxUtitlizationFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          BoxUtitlizationFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilization', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(BoxUtitlizationFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [] })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  render() {
    const { classes, t } = this.props;
    const {
      data,
      isButtonDisabled,
      toggleGraph,
      graphUrl,
    } = this.state;

    const columnDefs = [
      { field: "store", headerName: t("Report.KioskUtil.Store") },
      { field: "box", headerName: t("Report.KioskUtil.Box") },
      { field: "total_bins", headerName: t("Report.KioskUtil.TotalBins"), filter: false },
      { field: "available_bins", headerName: t("Report.KioskUtil.AvailableBins"), filter: false },
      { field: "use_bins", headerName: t("Report.KioskUtil.UsedBins"), filter: false },
      { field: "stock_bins", headerName: t("Report.KioskUtil.StockedBins"), filter: false },
      { field: "utilization", headerName: t("Report.KioskUtil.Utilization"), filter: false },
      {
        field: "utilization_date", headerName: t("Report.KioskUtil.Date"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.KioskUtil.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.KioskUtil.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
    ];

    return (
      <Paper>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <div>
          {toggleGraph ? (
            <React.Fragment>
              <div
                style={{
                  margin: '10px',
                  display: 'flex',
                  alighItem: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.setState({ toggleGraph: false });
                  }}
                >
                  Table View
                </Button>
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.fetchGraph(true);
                  }}
                >
                  Email Graph
                </Button>
              </div>
              <img src={graphUrl} alt='' />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>
                <Table className={classes.table} aria-labelledby='tableTitle'>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          width: '15%',
                          borderBottom: 'none',
                        }}
                      >
                        <Button
                          onClick={() => {
                            this.setState({ toggleGraph: true });
                          }}
                        >
                          Graph View
                        </Button>
                      </TableCell>
                      <TableCell
                        style={{
                          width: '25%',
                          borderBottom: 'none',
                          textAlign: 'right',
                        }}
                      >
                        <Tooltip key="clear-filters" title={t("Report.KioskUtil.ClearFiltersTooltip")}>
                          <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                            <CloseIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title={t('Report.KioskUtil.ExportCSVTooltip')}
                          style={{ marginRight: '0' }}
                          aria-label='ExportCSV'
                        >
                          <IconButton disabled={isButtonDisabled}>
                            <img
                              alt='download'
                              src={download}
                              onClick={() => this.exportCSV()}
                              style={{
                                height: '32px',
                                width: '32px',
                                cursor: 'pointer',
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <ReportsAGGrid
                  columnDefs={columnDefs}
                  sideBar={false}
                  suppressMenuHide={true}
                  rowData={data}
                  defaultColDef={{
                    flex: 1,
                    minWidth: 150,
                    floatingFilter: true,
                    filter: 'agTextColumnFilter',
                    filterParams: {
                      filterOptions: [{
                        displayKey: 'searchtext',
                        displayName: 'Search Text',
                        predicate: (cellValue) => cellValue
                      }],
                      maxNumConditions: 1,
                    },
                    resizable: true,
                    sortable: true,
                    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
                  }}
                  onGridReady={this.onGridReady}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      </Paper>
    );
  }
}

KioskBoxUtilization.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(KioskBoxUtilization));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/index.js